import React from "react";
import uiConfig from "../../config/uiConfig";

import {
  Box,
  Typography,
  Button,
} from "@mui/material";


import DownloadIcon from "@mui/icons-material/Download";



function DashboardHeader({ userName = "User" }) {


  const today = new Date().toLocaleDateString(
    "en-US",
    {
      weekday:"long",
      year:"numeric",
      month:"long",
      day:"numeric",
    }
  );



  return (

    <Box

      display="flex"

      justifyContent="space-between"

      alignItems="center"

      mb={3}

    >



      <Box>


        <Typography

          variant="h4"

          fontWeight={700}

          color="#0f172a"

        >

          Welcome back, {userName} 👋

        </Typography>




        <Typography

          variant="body2"

          color="text.secondary"

          mt={0.5}

        >

          Here's what's happening with your service desk today.

        </Typography>



      </Box>







      <Box

        display="flex"

        alignItems="center"

        gap={2}

      >



      </Box>



    </Box>

  );

}



export default DashboardHeader;